import { render, staticRenderFns } from "./BaseVirtualList.vue?vue&type=template&id=931e5896&scoped=true&"
import script from "./BaseVirtualList.vue?vue&type=script&lang=js&"
export * from "./BaseVirtualList.vue?vue&type=script&lang=js&"
import style0 from "./BaseVirtualList.vue?vue&type=style&index=0&id=931e5896&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "931e5896",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VVirtualScroll } from 'vuetify/lib/components/VVirtualScroll';
installComponents(component, {VVirtualScroll})
